/* eslint-disable no-undef */
import React from 'react';
import { ApiV1Base, ApiPrefixV1, getCookie, json, statusCheck } from 'util/icwUtility';

const useUploadFile = (onProgress, onError, onSuccess, endpoint = 'upload/multiple/file') => {
  const [isUploading, setIsUploading] = React.useState(false);
  const upload = async (files) => {
    setIsUploading(true);
    const formData = new FormData();
    for (let i = 0; i < files.length; i++) {
      formData.append('file', files[i], files[i].name);
    }
    try {
      const response = await fetch(`${ApiV1Base}${ApiPrefixV1}/${endpoint}`, {
        method: 'POST',
        headers: {
          Authorization: getCookie('token'),
        },
        body: formData,
        onUploadProgress: (progressing) => {
          if (onProgress) {
            onProgress(progressing);
          }
        },
      });
      await statusCheck(response);
      const data = await json(response);
      setIsUploading(false);
      if (onSuccess) {
        onSuccess(data);
      }
      return data;
    } catch (error) {
      setIsUploading(false);
      if (onError) {
        onError(error);
      }
      throw error;
    }
  };
  return {
    upload,
    isUploading,
  };
};

export default useUploadFile;
